export const checkCanCancelOrders = (currentUser) => {
  // 1. Super Admin tem permissão total
  const role = localStorage.getItem('currentUserRole') || currentUser?.role;
  if (role === 'admin_TOTAL') return true;

  // 2. Permissões salvas no localStorage
  try {
    const permsRaw = localStorage.getItem('currentUserPermissions');
    if (permsRaw) {
      const perms = JSON.parse(permsRaw);
      if (
        Array.isArray(perms) &&
        (perms.includes('cancelOrder') ||
          perms.includes('cancel_orders') ||
          perms.includes('cancelar pedidos') ||
          perms.includes('ALL'))
      ) {
        return true;
      }
    }
  } catch (e) {
    console.error('Erro ao ler permissões do localStorage:', e);
  }

  // 3. Permissões no objeto currentUser
  if (currentUser) {
    if (currentUser.role === 'admin_TOTAL') return true;
    const perms = currentUser.permissions;
    if (
      Array.isArray(perms) &&
      (perms.includes('cancelOrder') ||
        perms.includes('cancel_orders') ||
        perms.includes('cancelar pedidos') ||
        perms.includes('ALL'))
    ) {
      return true;
    }
  }

  return false;
};

